import React from 'react';
import PropTypes from 'prop-types';

import {
  MenuList,
  MenuListItem,
  SVGIcon,
} from '@pearsontechnology/aero-components';

import { getIcon } from 'Workspace/helpers';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import pluginTypes, { otherMenuItems } from 'constants/pluginTypes';
import { gtmTrackAuthoringCourseContentUserInteraction } from 'utils/gtm/handler';
import { GTM_EVENT_CATEGORY, GTM_EVENT_ACTION } from 'utils/gtm/constants';
import messages from './messages';
import { Menu, MenuListItemText } from './styles';

const menuPluginList = [
  pluginTypes.COURSE,
  pluginTypes.LESSON,
];

const AddProjectContentMenu = ({ openModalSelector, isImportEpubEnabled, isCornucopiaPhaseOneEnabled }) => {
  const menuList = [...menuPluginList];
  
  if (isCornucopiaPhaseOneEnabled) {
    menuList.push(pluginTypes.ETEXT);
  }
  if (isImportEpubEnabled) {
    menuList.push(otherMenuItems.IMPORT);
  }

  const handleMenuItemClick = (menuItemType) => {
    // Event ID 19 — Select Import Content Type
    gtmTrackAuthoringCourseContentUserInteraction({
      eventCategory: GTM_EVENT_CATEGORY.COURSE_PROJECT_DASHBOARD,
      eventAction: GTM_EVENT_ACTION.SELECT_IMPORT_CONTENT_TYPE_FROM_DROPDOWN,
      eventLabel: intl.formatMessage(messages[menuItemType]),
      locationInApp: 'Select a Project in Courseware > Click on Add Content Dropdown > Select Import Content Type From Dropdown',
    });

    openModalSelector(menuItemType);
  };

  return (
    <Menu>
      <MenuList>
        {menuList.map((menuItemType) => (
          <MenuListItem
            key={menuItemType}
            onClick={() => handleMenuItemClick(menuItemType)}
          >
            <SVGIcon
              icon={getIcon(menuItemType)}
              viewBox="0 0 24 24"
            />
            <MenuListItemText>
              {intl.formatMessage(messages[menuItemType])}
            </MenuListItemText>
          </MenuListItem>
        ))}
      </MenuList>
    </Menu>
  );
};

AddProjectContentMenu.propTypes = {
  openModalSelector: PropTypes.func.isRequired,
  isImportEpubEnabled: PropTypes.bool,
};

export default AddProjectContentMenu;
